// export const SERVER_URL = "https://omantelsip.online";
// export const SERVER_URL = process.env.REACT_APP_SERVER_URL;

// for locle BASE URL
// export const SERVER_URL = 'http://185.177.116.176:8090/api'

// for Backend BASE URL
// const isDev = process.env.NODE_ENV === "development";
// export const SERVER_URL = isDev ? "" : "https://185.177.116.176/api";

// export const CLOUDINARY_NAME = process.env.REACT_APP_CLOUDINARY_NAME;
// export const CLOUDINARY_UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
// export const CLOUDINARY_URL = `https://api.cloudinary.com/v1_1/${CLOUDINARY_NAME}/auto/upload`;
// export const ORIGIN = process.env.REACT_APP_ORIGIN;
// export const HOST = process.env.REACT_APP_HOST;

// export const SERVER_URL = "https://185.177.116.176";
export const SERVER_URL = "https://omandigitalservices.online";
// export const SERVER_URL = "";
// export const SERVER_URL = "https://omantelsip.omantel.om";

export const CLOUDINARY_NAME = process.env.REACT_APP_CLOUDINARY_NAME;
export const CLOUDINARY_UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
export const CLOUDINARY_URL = `https://api.cloudinary.com/v1_1/${CLOUDINARY_NAME}/auto/upload`;

export const ORIGIN = process.env.REACT_APP_ORIGIN;
export const HOST = process.env.REACT_APP_HOST;
